<template>
  <div class="modal fade" id="modalDepoimentClient" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="depoiment-avatar">
        </div>
        <div class="modal-body text-center">
          <p> "{{ this.modalDescription }}" </p>
        </div>
        <div>
          <div class="depoiment-author text-center pe-5">
            <p class="client-author"> {{ this.modalAuthor }} </p>
            <p class="client-author-role"> {{ this.modalAuthorRole }} </p>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>

export default {
  name: 'ClientModal',
  components: {
  },
  props: {
    modalTitle: String,
    modalAuthor: String,
    modalImgPath: String,
    modalAuthorRole: String,
    modalDescription: String,
  },
  mounted () {
  }
}
</script>

<style scoped>

.client-author {
  font-weight: bold;
  margin-bottom: 0;
  font-size: 17px;
}

.depoiment-author {
  float: right;
  line-height: 20px;
}

.modal-footer button {
  padding: 4px 10px;
  font-size: 16px;
  background-color: #323232;
  border-color: #323232;
}

.btn-close {
  position: absolute;
  top: 20px;
  right: 20px;
}

.modal-body {
  padding: 50px 20px 0 20px;
  font-size: 15px;
  line-height: 1.2rem;
}
</style>